export const UKCountriesList = [
  { label: "England", value: "ENG" },
  { label: "Scotland", value: "SCT" },
  { label: "Wales", value: "WAL" },
  { label: "Northern Ireland", value: "NIR" },
];
